import {
  ADD_APPLICATION_TAB,
  REMOVE_APPLICATION_TAB,
  CHANGE_SELECTED_APPLICATION_TAB,
  UPDATE_TAB_LOADING_STATUS,
  ADD_EMPTY_TAB,
  UPDATE_APPLICATION_TAB,
} from '../constants/action-types';

export const addApplicationTab = (audience, appName) => ({
  type: ADD_APPLICATION_TAB,
  audience,
  appName,
});

export const addEmptyTab = () => ({
  type: ADD_EMPTY_TAB,
});

export const updateApplicationTab = (id, audience, appName) => ({
  type: UPDATE_APPLICATION_TAB,
  id,
  audience,
  appName,
});

export const removeApplicationTab = id => ({
  type: REMOVE_APPLICATION_TAB,
  id,
});

export const changeSelectedApplicationTab = id => ({
  type: CHANGE_SELECTED_APPLICATION_TAB,
  id,
});

export const updateTabLoadingStatus = tabId => ({
  type: UPDATE_TAB_LOADING_STATUS,
  tabId,
});
